var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { VehicleModelAudioDto } from '../../../classes/vehicle-model/response/vehicle-model-audio.dto';
import { VehicleModelKeyOptionDto } from '../../../classes/vehicle-model/response/vehicle-model-key-option.dto';
import { VehicleModelOptionDto } from '../../../classes/vehicle-model/response/vehicle-model-option.dto';
import { VehicleModelWithoutRelationsDto } from '../../../classes/vehicle-model/response/vehicle-model-without-relations.dto';
import { BranchDto } from '../../branch';
import { BaseNumberIdDataDto } from '../../common';
import { GarageDto } from '../../garage';
import { VehicleAccidentWithoutRelationsDto } from '../../vehicle-accident';
import { VehicleMaintenanceWithoutRelationsDto } from '../../vehicle-maintenance';
export class VehicleDto extends BaseNumberIdDataDto {
    constructor(initializer) {
        super(initializer);
        this.vehicleNumber = initializer.vehicleNumber;
        this.registeredAt = initializer.registeredAt;
        this.state = initializer.state;
        this.age = initializer.age;
        this.mileage = initializer.mileage;
        this.inspectionDue = initializer.inspectionDue;
        this.expirationDate = initializer.expirationDate;
        this.color = initializer.color;
        this.audio = initializer.audio;
        this.vehicleOption = initializer.vehicleOption;
        this.keyOption = initializer.keyOption;
        this.memo = initializer.memo;
        this.vehicleModel = initializer.vehicleModel;
        this.vehicleModelId = initializer.vehicleModelId;
        this.garage = initializer.garage;
        this.garageId = initializer.garageId;
        this.branch = initializer.branch;
        this.branchId = initializer.branchId;
        this.vehicleMaintenances = initializer.vehicleMaintenances;
        this.vehicleAccidents = initializer.vehicleAccidents;
    }
}
__decorate([
    Type(() => Date),
    __metadata("design:type", Date)
], VehicleDto.prototype, "registeredAt", void 0);
__decorate([
    Type(() => Date),
    __metadata("design:type", Object)
], VehicleDto.prototype, "inspectionDue", void 0);
__decorate([
    Type(() => Date),
    __metadata("design:type", Object)
], VehicleDto.prototype, "expirationDate", void 0);
__decorate([
    Type(() => VehicleModelAudioDto),
    __metadata("design:type", VehicleModelAudioDto)
], VehicleDto.prototype, "audio", void 0);
__decorate([
    Type(() => VehicleModelOptionDto),
    __metadata("design:type", VehicleModelOptionDto)
], VehicleDto.prototype, "vehicleOption", void 0);
__decorate([
    Type(() => VehicleModelKeyOptionDto),
    __metadata("design:type", VehicleModelKeyOptionDto)
], VehicleDto.prototype, "keyOption", void 0);
__decorate([
    Type(() => VehicleModelWithoutRelationsDto),
    __metadata("design:type", VehicleModelWithoutRelationsDto)
], VehicleDto.prototype, "vehicleModel", void 0);
__decorate([
    Type(() => GarageDto),
    __metadata("design:type", Object)
], VehicleDto.prototype, "garage", void 0);
__decorate([
    Type(() => BranchDto),
    __metadata("design:type", BranchDto)
], VehicleDto.prototype, "branch", void 0);
__decorate([
    Type(() => VehicleMaintenanceWithoutRelationsDto),
    __metadata("design:type", Array)
], VehicleDto.prototype, "vehicleMaintenances", void 0);
__decorate([
    Type(() => VehicleAccidentWithoutRelationsDto),
    __metadata("design:type", Array)
], VehicleDto.prototype, "vehicleAccidents", void 0);
